import React from 'react';
import {Form, Formik} from 'formik';
import * as Yup from "yup";
import ConclusionCard from '../../../conclusionCard';
import Guarantees from './components/guarantees';

interface IPurchaseFormProps {
  onSubmit: (formValues) => Promise<any>;
  hidePurchaseButton?: boolean;
  isProductOwner: boolean;
  isOrderOwner: boolean;

  originalPrice?: number;
  salePrice?: number;
  currency?: number;
  details?: any;
  top?: any;
  aboveComponent?: any;

  initialValues?: any;
}

const PurchaseForm = (props: IPurchaseFormProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      validationSchema={Yup.object({})}
      onSubmit={async (values, {setSubmitting}) => {
        await props
          .onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize={true}
    >
      {({submitForm, isSubmitting, values, touched, errors}) => {
        return (
          <Form translate={null}>
            <ConclusionCard
              className={'purchaseConclusion'}
              salePrice={props.salePrice}
              originalPrice={props.originalPrice}
              currency={props.currency}
              hideBottom={props.hidePurchaseButton || props.isProductOwner || props.isOrderOwner}
              hideDiscount={props.isProductOwner}
              submitForm={submitForm}
              isSubmitting={isSubmitting}
              aboveComponent={props.aboveComponent}

              top={props.details || props.top}
              showTopPriceConclusion={props.details ? false : true}
            />
          </Form>
        )
      }}
    </Formik>
  );
};

PurchaseForm.defaultProps = {
  isProductOwner: false,
  isOrderOwner: false,
  initialValues: {},
};

export default React.memo(PurchaseForm);
